import { cityError, emailError, nameError, phoneError, streetError, zipCodeError, zipCodeServiceError, } from '../../../constants/errors';
import { email as emailReg } from '../../../constants/regExp';
import { getPartner } from '../../../selectors/partner';
import { getServicedZipCodes } from '../../../selectors/zipCode';
import { store } from '../../../store/configureStore';
var validation = function (values, withoutValidation, isPartner) {
    var _a;
    if (isPartner === void 0) { isPartner = false; }
    var partner = getPartner(store.getState());
    var servicedZipCodes;
    if (isPartner && ((_a = partner === null || partner === void 0 ? void 0 : partner.zipCodes) === null || _a === void 0 ? void 0 : _a.length)) {
        servicedZipCodes = partner.zipCodes.reduce(function (acc, zipCode) {
            if (zipCode === null || zipCode === void 0 ? void 0 : zipCode.zipCode) {
                // @ts-ignore
                acc[zipCode.zipCode] = zipCode;
            }
            return acc;
        }, {});
    }
    else {
        servicedZipCodes = getServicedZipCodes(store.getState());
    }
    var errors = {};
    if (!(withoutValidation === null || withoutValidation === void 0 ? void 0 : withoutValidation.name) && !(values === null || values === void 0 ? void 0 : values.name)) {
        errors.name = nameError;
    }
    if (!(withoutValidation === null || withoutValidation === void 0 ? void 0 : withoutValidation.email)) {
        if (!(values === null || values === void 0 ? void 0 : values.email) || !emailReg.test(values.email)) {
            errors.email = emailError;
        }
    }
    if (!(withoutValidation === null || withoutValidation === void 0 ? void 0 : withoutValidation.phone) && !(values === null || values === void 0 ? void 0 : values.phone)) {
        errors.phone = phoneError;
    }
    if (!(values === null || values === void 0 ? void 0 : values.street)) {
        errors.street = streetError;
    }
    if (!(values === null || values === void 0 ? void 0 : values.city)) {
        errors.city = cityError;
    }
    if (!(withoutValidation === null || withoutValidation === void 0 ? void 0 : withoutValidation.zipCode) && !(servicedZipCodes === null || servicedZipCodes === void 0 ? void 0 : servicedZipCodes[values === null || values === void 0 ? void 0 : values.zipCode])) {
        errors.zipCode = zipCodeServiceError;
    }
    if (!(values === null || values === void 0 ? void 0 : values.zipCode) || String(values.zipCode).length !== 5) {
        errors.zipCode = zipCodeError;
    }
    return errors;
};
export default validation;
//# sourceMappingURL=details.js.map